import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Button from "../sections/MUI/Button";
import Field from "../sections/MUI/Field";
import req from "../req";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";
import Select from "../sections/MUI/Select";

class BlackList extends Component {

    state = {
        list: [],
        term: "",
        sendSMS: "no"
    };

    componentDidMount() {
        this.getList();
    }


    getList() {
        req.get(`/black-list`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                list.reverse();
                this.setState({list});
            });
    }

    submit() {
        let {term, sendSMS} = this.state;
        term = term ? term.toString().replace(/ /g, "").trim() : "";
        sendSMS = sendSMS ? sendSMS.toString().trim().toString() : "no";
        if (term.length < 8) {
            return toast.error("شماره ملی یا شماره موبایل نامعتبر است!", {autoClose: 1500});
        }
        if (isNaN(Number(term))) {
            return toast.error("شماره ملی یا شماره موبایل نامعتبر است!");
        }
        toast.info("در حال ثبت مسدودی ...", {autoClose: 1000});
        return req.post(`/black-list`, {
            term,
            ss: sendSMS
        })
            .then(r => {
                if (r) {
                    if (r.message) {
                        toast.success(r.message, {autoClose: 4500});
                    } else {
                        toast.success("با موفقیت مسدود شد.");
                    }
                    this.setState({term: "", list: []});
                    this.getList();
                }
            })
            .catch(err => {
            });
    }

    delete(term = "") {
        toast.info("در حال حذف مسدودی ...", {autoClose: 1000});
        req.delete(`/black-list?term=${term}`)
            .then(r => {
                if (r) {
                    toast.success("با موفقیت حذف شد.");
                    this.getList();
                }
            });
    }

    render() {
        let {list, term, sendSMS} = this.state;
        return (
            <div className="black-list">
                <Back {...this.props}/>
                <br/>
                <div className="save">
                    <div className="row">
                        <div className="col-5">
                            <Field name="term"
                                   label="کد ملی یا شماره موبایل"
                                   maxLength={12}
                                   type="number"
                                   style={{direction: "ltr"}}
                                   onChange={(name, value) => this.setState({[name]: value.replace(/ /g, "")})}
                                   value={term}/>
                        </div>
                        <div className="col-4">
                            <Select simple
                                    name="sendSMS"
                                    value={sendSMS}
                                    onChange={(name, value) => this.setState({[name]: value})}
                                    options={[
                                        {t: "❌ پیامک ارسال نشود", v: "no"},
                                        {t: "✅ پیامک ارسال شود", v: "yes"}
                                    ]}/>
                        </div>
                        <div className="col-3">
                            <Button icon="check"
                                    onDoubleClick={() => this.submit()}>ذخیره (دوبار کلیک)</Button>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="list">
                    <div className="row justify-content-center">
                        {
                            list?.length > 0 ?
                                list?.map((it, i) =>
                                    <div className="col-md-4" key={"blit" + i}>
                                        <article>
                                            <div className="row">
                                                <div className="col">
                                                    <div className="item">
                                                        <span className="term">{it}</span>
                                                        <span
                                                            className="type">{(it.startsWith("09") && it.length === 11) ? "شماره موبایل" : "کد ملی"}</span>
                                                    </div>

                                                </div>
                                                <div className="col-auto">
                                                    <Icon i="trash" className="delete-icon"
                                                          onDoubleClick={() => this.delete(it.toString().trim())}/>
                                                </div>
                                            </div>

                                        </article>
                                    </div>
                                )
                                : <div style={{
                                    textAlign: "center",
                                    fontSize: "14pt",
                                    padding: "16px 0",
                                    color: "#656565",
                                    userSelect: "none"
                                }}>هورا! مسدودی نداریم</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(BlackList);